export default __webpack_public_path__ + "static/Jesse_Rivest_Toadstool_007-f6634d5ba1d206e09a3d46eed43d1bdd.jpg";